import React, { Fragment } from 'react';
import { string, func, object, arrayOf, bool } from 'prop-types';

import SearchForm from '../containers/SearchForm';
import SearchResults from '../containers/SearchResults';


const Search = ({
    onSubmit,
    initialValues,
    placeholder,
    filters,
    systemPortalList,
}) => (
    <Fragment>
        <SearchForm
            onSubmit={onSubmit}
            initialValues={initialValues}
            filters={filters}
            placeholder={placeholder}
            systemPortalList={systemPortalList}
        />

        <SearchResults filters={filters} />
    </Fragment>
);

Search.propTypes = {
    onSubmit: func.isRequired,
    initialValues: object,
    filters: arrayOf(string.isRequired),
    placeholder: string,
    systemPortalList: bool,
};

export default Search;
